import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-background-200 bg-secondary-950 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                17
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">17爆料网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">{siteInfo.intro}</p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-800 text-background-100">
                <i className="ri-mail-line text-base"></i>
              </span>
              <a href={`mailto:${siteInfo.email}`} className="text-sm text-background-200 transition-colors hover:text-background-50 cursor-pointer">
                {siteInfo.email}
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?cat=${cat.id}`}
                    className="text-sm text-background-300 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">网站导航</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 transition-colors hover:text-background-50 cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/topics" className="text-sm text-background-300 transition-colors hover:text-background-50 cursor-pointer">热点聚合</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 transition-colors hover:text-background-50 cursor-pointer">关于我们</Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-background-300 transition-colors hover:text-background-50 cursor-pointer">常见问题</Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-300 transition-colors hover:text-background-50 cursor-pointer">联系我们</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 17爆料网 · 内容基于公开信息整理，仅供参考与讨论。</p>
          <p>本站不发布个人隐私信息，如内容有误欢迎通过联系页面反馈更正。</p>
        </div>
      </div>
    </footer>
  );
}